
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt, FaUserTie } from 'react-icons/fa'
import { HiDocumentText } from 'react-icons/hi2'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import ClientSummaryModal from './ClientSummaryModal'
import api from '../../../utils/api'

import './ListClientRow.css'

import EditClient from '../EditClient'
import SelectSellers from '../SelectSellers/SelectSellers'
import { formatCNPJ } from '../../../shared/functions/cnpjFormat'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


const formatSellerNames = (users) => {
    const names = (users || []).map((u) => u.name).filter(Boolean)
    if (names.length === 0) return 'Nenhum vendedor'
    if (names.length <= 2) return names.join(', ')
    return `${names.slice(0, 2).join(', ')} +${names.length - 2}`
}

function ListClientRow({ dataArray, myPermissionView, myPermissionDelete, myPermissionEdit, handleOnSelect, selectedArray, handleOnSuccess, sellerEnabled, fakeDelete }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditClient, setModalEditClient] = useState(false)
    const [modalEditSellers, setModalEditSellers] = useState(false)
    const [clientId, setClientId] = useState("")
    const [client, setClient] = useState({})
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [clientName, setClientName] = useState("")
    const [modalSummary, setModalSummary] = useState(false)
    const [summaryItem, setSummaryItem] = useState(null)

    async function deleteClient(id) {
        let msgType = 'success'
        const request = fakeDelete
            ? api.patch(`/client/disable/${id}`, {}, { headers: { Authorization: `Bearer ${JSON.parse(token)}` } })
            : api.delete(`/client/delete/${id}`, { headers: { Authorization: `Bearer ${JSON.parse(token)}` } })

        const data = await request.then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    const saveAssociatedUsers = async (sellersList) => {
        let msgType = 'success'
        const data = await api.patch(`/client/sellers/${client._id}`, { associatedUsers: sellersList }, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => response.data).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            setModalEditSellers(false)
            handleOnSuccess()
        }
    }


    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <div className='client-row-text'>
                            <span className='client-row-name'>{item.name}</span>
                            <div className='client-row-meta'>
                                {item.disabled && (
                                    <span className="pg-item-status-disabled">Desabilitado</span>
                                )}
                                {item.personType && (
                                    <span className={`client-type-badge client-type-${item.personType}`}>
                                        {item.personType === 'juridica' ? 'PJ' : 'PF'}
                                    </span>
                                )}
                                {item.personType === 'juridica' && item.CNPJ && (
                                    <span className='client-row-doc'>{formatCNPJ(item.CNPJ)}</span>
                                )}
                                {item.personType === 'fisica' && item.CPF && (
                                    <span className='client-row-doc'>{item.CPF}</span>
                                )}
                            </div>
                            {sellerEnabled && (
                                <div className='client-row-links'>
                                    <span className='client-row-link-item'>
                                        <FaUserTie size={11} />
                                        {formatSellerNames(item.associatedUsers)}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionView &&
                            <HiDocumentText className='client-icon-row-summary' title='Ver Resumo' onClick={() => { setSummaryItem(item); setModalSummary(true) }} />
                        }
                        {sellerEnabled &&
                            <FaUserTie className='shd-icon-row-sellers' title='Vendedores associados' onClick={() => { setClient(item); setModalEditSellers(true) }} />
                        }
                        {myPermissionEdit &&
                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setClientId(item._id); setModalEditClient(true) }} />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setClientId(item._id); setClientName(item.name) }} />
                        }
                    </div>
                </div>
            ))
        }
    }




    return (


        <div>
            {listArray()}

            <>
                <Modal
                    modalStatus={modalEditClient}
                    changeStatus={setModalEditClient}
                    t={3}
                    w={88}
                    h={90}
                    content={
                        <>
                            <EditClient id={clientId} handleOnSuccess={() => { setModalEditClient(false); handleOnSuccess() }} btCancelAction={() => setModalEditClient(false)} />
                        </>
                    }
                />
            </>

            <Modal
                modalStatus={modalEditSellers}
                changeStatus={setModalEditSellers}
                w={70}
                content={
                    <SelectSellers
                        data={client}
                        dataArray={client.associatedUsers}
                        readOnly={!myPermissionEdit}
                        handleOnSave={saveAssociatedUsers}
                        btCancelAction={() => setModalEditSellers(false)}
                    />
                }
            />

            {modalSummary && (
                <ClientSummaryModal
                    client={summaryItem}
                    onClose={() => setModalSummary(false)}
                />
            )}

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteClient(clientId)}
                message="Deseja realmente excluir esse cliente?"
                itemName={clientName}
            />

        </div>
    )
}

export default ListClientRow
